import React, { useRef, useState, useEffect } from 'react'
import { IconButton } from '@st-operations/uikit/src/v2'

import './styles.scss'

const TitleEditor = ({ title: defaultTitle, onTitleSubmit }) => {
  const inputRef = useRef(null)

  const [title, setTitle] = useState()
  const [editing, setEditing] = useState(false)

  const handleStartEditing = () => {
    setEditing(true)
    inputRef.current.focus()
  }

  const handleCancelEditing = () => {
    handleStopEditing()
    setTitle(defaultTitle)
  }

  const handleStopEditing = () => {
    setEditing(false)
  }

  const handleInputChange = (event) => {
    setTitle(event.target.value)
  }

  const handleSubmit = () => {
    onTitleSubmit?.(title)
    handleStopEditing()
  }

  const handleInputKeyDown = (event) => {
    if (event.key === 'Enter') {
      handleSubmit()
    }

    if (event.key === 'Escape') {
      handleCancelEditing()
    }
  }

  useEffect(
    function refreshTitle() {
      setTitle(defaultTitle)
    },
    [defaultTitle]
  )

  return (
    <div className="title-editor__container">
      <If condition={!editing}>
        <>
          <h2 className="title-editor__title">{title}</h2>
          <IconButton
            className="title-editor__edit-icon"
            iconProps={{ icon: 'edit', width: 24, height: 24, color: 'currentColor' }}
            onClick={handleStartEditing}
          />
        </>
      </If>
      <input
        ref={inputRef}
        style={editing ? { opacity: 1, width: `${title.length}ch` } : { width: 0, opacity: 0 }}
        className="title-editor__input"
        value={title}
        onBlur={handleSubmit}
        onKeyDown={handleInputKeyDown}
        onChange={handleInputChange}
      />
    </div>
  )
}

export default TitleEditor
